(function () {
  const DEFAULT_BASE_URL = 'https://customer-service-test-us.zerozero.cn';

  const DEFAULT_TIMEOUT = 60000;

  function getToken() {
    return localStorage.getItem('token') || '';
  }

  function buildUrl(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return queryString ? `${url}?${queryString}` : url;
  }

  function timeoutFetch(fetchPromise, timeout = DEFAULT_TIMEOUT) {
    return Promise.race([
      fetchPromise,
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('请求超时，请重试')), timeout)
      ),
    ]);
  }

  function request(method, url, params = {}, options = {}) {
    const baseUrl = options.baseUrl || DEFAULT_BASE_URL;

    const timeout = options.timeout || DEFAULT_TIMEOUT;

    const fullUrl = baseUrl + url;

    let fetchOptions = {
      method: method.toUpperCase(),
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    };

    if (method.toLowerCase() === 'get') {
      return timeoutFetch(
        fetch(buildUrl(fullUrl, params), fetchOptions),
        timeout
      ).then(handleResponse);
    } else {
      fetchOptions.body = JSON.stringify(params);
      return timeoutFetch(fetch(fullUrl, fetchOptions), timeout).then(
        handleResponse
      );
    }
  }

  function handleResponse(response) {
    if (!response.ok) {
      if (response.status === 401) {
        // 未登录或登录过期，即将跳转登录页, 暂不处理
      }
      return response.json().then((err) => {
        throw err;
      });
    }
    return response.json();
  }

  window.httpRequest = {
    get: function (url, params = {}, options = {}) {
      return request('get', url, params, options);
    },
    post: function (url, params = {}, options = {}) {
      return request('post', url, params, options);
    },
  };
})();
